import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mantine/core';
import {
  DefaultValues,
  FieldValues,
  FormProvider,
  SubmitHandler,
  useForm,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { FormActions } from '../../../FormActions';

type RootPropsType<T extends FieldValues> = {
  schema: z.ZodType<T, T>;
  defaultValues: DefaultValues<T>;
  onSave: SubmitHandler<T>;
  onCancel: () => void;
  children: React.ReactNode;
};

export const Root = <T extends FieldValues>({
  schema,
  defaultValues,
  onSave,
  onCancel,
  children,
}: RootPropsType<T>): React.ReactElement => {
  const { t } = useTranslation();
  const methods = useForm<T>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSave)}>
        <Stack gap="md">
          {children}
          <FormActions
            onCancel={onCancel}
            saveButtonText={t('SAVE_BUTTON')}
            cancelButtonText={t('CANCEL_BUTTON')}
          />
        </Stack>
      </form>
    </FormProvider>
  );
};
